import { Form, Formik } from "formik";
import PasswordInput from "../UI/PasswordInput";
import FormikSubmitButton from "../UI/FormikSubmitButton";
import {
  changePasswordInitialValues,
  changePasswordSchema,
} from "../../models/changePassword";

export default function ChangePasswordForm({ onSubmit }) {
  async function submitHandler(values) {
    try {
      await onSubmit(values);
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <Formik
      initialValues={changePasswordInitialValues}
      enableReinitialize={true}
      validationSchema={changePasswordSchema}
      onSubmit={submitHandler}
    >
      <Form>
        <PasswordInput name={"old_password"} label={"Ancien mot de passe"} />
        <PasswordInput name={"new_password"} label={"Nouveau mot de passe"} />
        <PasswordInput
          name={"dnew_password"}
          label={"Entrez de nouveau le mot de passe"}
        />

        <div className={"text-right"}>
          <FormikSubmitButton>Valider</FormikSubmitButton>
        </div>
      </Form>
    </Formik>
  );
}
